/**
 * @class
 * @description
 * Base class for ezClocker Enumerations
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Provides the following properties:
 *  ready: boolean
 *  ezStates: array
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * @deprecated
 * Stop all use of this - enumerations will no longer register with ezApi.
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */
export class EzEnum {
    /**
     * @public @static @property
     * Default UNKNOWN enumeration property/value
     * @type {string}
     * @deprecated
     * Stop all use: Migrate to using EzEnumeration2 instead of EzEnum.
     */
    static get UNKNOWN() {
        return 'UNKNOWN';
    }

    /**
     * @public @consructor
     * Creates a new instance of EzEnum
     * @deprecated
     * Stop all use: Migrate to using EzEnumeration2 instead of EzEnum.
     */
    constructor() {
        this.ezStates.push('CONSTRUCTED');
    }

    /**
     * @public @property
     * Stores if this class is ready to use
     * @type {boolean}
     * @deprecated
     * Stop all use: Migrate to using EzEnumeration2 instead of EzEnum.
    */
    #ready = false;
    /**
     * @public @method
     * Returns if this instance is ready to use
     * @returns {boolean}
     * @deprecated
     * Stop all use: Migrate to using EzEnumeration2 instead of EzEnum.
    */
    get ready() {
        if (globalThis?.console?.debug) {
            globalThis.console.debug(
                this.#ready
                    ? `[Enumeration ${this.constructor.name}: READY]`
                    : `[Enumeration ${this.constructor.name}: NOT READY YET]`);
        }

        return this.#ready;
    }
    /**
     * @public @method
     * Sets if this instance is ready to use
     * @param {boolean} ready
     * Default: false
     * @deprecated
     * Stop all use: Migrate to using EzEnumeration2 instead of EzEnum.
     */
    set ready(ready = false) {
        this.#ready = ready && 'boolean' === typeof ready
            ? ready
            : false;
    }

    /**
     * @public @property
     * Stores the EzInstanceStates for this instance
     * @type {array}
     * @deprecated
     * Stop all use: Migrate to using EzEnumeration2 instead of EzEnum.
    */
    #ezStates = [];
    /**
     * @public @method
     * Returns this instance's states
     * @returns {array}
     * @deprecated
     * Stop all use: Migrate to using EzEnumeration2 instead of EzEnum.
     */
    get ezStates() {
        return this.#ezStates;
    }
    /**
     * @public @method
     * Sets this instance's states
     * @param {undefined|null|array} ezStates
     * Default: []
     * @deprecated
     * Stop all use: Migrate to using EzEnumeration2 instead of EzEnum.
     */
    set ezStates(ezStates = []) {
        this.#ezStates = !ezStates || 'object' !== typeof ezStates || 'Array' !== ezStates.constructor.name
            ? ezStates
            : [];

        if (globalThis?.console?.debug) {
            globalThis.console.debug(`[Updated ${this.constructor.name}.ezStates to (${JSON.stringify(this.#ezStates)})]`);
        }
    }
}
